import React from "react";

function Logo() {
  return (
    <svg
      width="300"
      height="50"
      viewBox="0 0 438 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.3242 41.7136C68.3242 39.4777 70.071 37.8008 72.3768 37.8008C73.5646 37.8008 74.6126 38.22 75.3113 38.9886L74.6126 39.6873C74.0537 39.0585 73.2851 38.779 72.4466 38.779C70.6998 38.779 69.4422 40.0367 69.4422 41.7136C69.4422 43.3905 70.6998 44.6482 72.4466 44.6482C73.2851 44.6482 73.9838 44.3687 74.6126 43.7398L75.3113 44.4386C74.6126 45.2071 73.5646 45.6264 72.3768 45.6264C70.0011 45.6264 68.3242 44.0193 68.3242 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M87.8184 41.7136C87.8184 39.4777 89.5651 37.8008 91.8709 37.8008C94.1766 37.8008 95.9234 39.4777 95.9234 41.7136C95.9234 43.9495 94.1766 45.6264 91.8709 45.6264C89.4953 45.6264 87.8184 43.9495 87.8184 41.7136ZM94.8055 41.7136C94.8055 40.0367 93.5478 38.779 91.8709 38.779C90.1241 38.779 88.8664 40.0367 88.8664 41.7136C88.8664 43.3905 90.1241 44.6482 91.8709 44.6482C93.5478 44.6482 94.8055 43.3905 94.8055 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M115.208 37.9375V45.5535H114.3L109.688 39.8939V45.5535H108.57V37.9375H109.479L114.09 43.5971V37.9375H115.208Z"
        fill="currentColor"
      />
      <path
        d="M129.113 44.6447L129.533 43.8062C130.091 44.2953 131.07 44.7146 132.048 44.7146C133.375 44.7146 133.934 44.2255 133.934 43.5268C133.934 41.6402 129.323 42.8281 129.323 40.0332C129.323 38.8454 130.231 37.8672 132.257 37.8672C133.166 37.8672 134.074 38.0768 134.703 38.5659L134.354 39.4044C133.655 38.9851 132.956 38.7755 132.257 38.7755C130.93 38.7755 130.371 39.3345 130.371 39.9633C130.371 41.8499 134.982 40.662 134.982 43.4569C134.982 44.6447 134.074 45.6229 132.048 45.6229C130.86 45.6229 129.672 45.2037 129.113 44.6447Z"
        fill="currentColor"
      />
      <path
        d="M151.611 38.8454H149.025V37.8672H155.314V38.8454H152.729V45.553H151.681V38.8454H151.611Z"
        fill="currentColor"
      />
      <path
        d="M174.18 45.5535L172.503 43.1778C172.364 43.1778 172.154 43.1778 172.014 43.1778H170.128V45.4836H169.01V37.9375H172.014C173.971 37.9375 175.228 38.9157 175.228 40.5926C175.228 41.7804 174.599 42.6189 173.551 43.0381L175.368 45.6233H174.18V45.5535ZM174.11 40.5926C174.11 39.4747 173.412 38.8458 172.014 38.8458H170.128V42.2695H172.014C173.412 42.2695 174.11 41.6407 174.11 40.5926Z"
        fill="currentColor"
      />
      <path
        d="M189.062 42.2734V37.9414H190.18V42.2734C190.18 43.9503 190.949 44.7189 192.346 44.7189C193.744 44.7189 194.512 43.9503 194.512 42.2734V37.9414H195.561V42.2734C195.561 44.5093 194.373 45.6272 192.346 45.6272C190.25 45.6272 189.062 44.4394 189.062 42.2734Z"
        fill="currentColor"
      />
      <path
        d="M208.904 41.7136C208.904 39.4777 210.651 37.8008 212.957 37.8008C214.145 37.8008 215.193 38.22 215.891 38.9886L215.193 39.6873C214.634 39.0585 213.865 38.779 213.027 38.779C211.28 38.779 210.022 40.0367 210.022 41.7136C210.022 43.3905 211.28 44.6482 213.027 44.6482C213.865 44.6482 214.564 44.3687 215.193 43.7398L215.891 44.4386C215.193 45.2071 214.145 45.6264 212.957 45.6264C210.651 45.6264 208.904 44.0193 208.904 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M231.894 38.8454H229.309V37.8672H235.597V38.8454H233.012V45.553H231.964V38.8454H231.894Z"
        fill="currentColor"
      />
      <path
        d="M252.016 37.9375H253.134V45.5535H252.016V37.9375Z"
        fill="currentColor"
      />
      <path
        d="M268.576 41.7136C268.576 39.4777 270.323 37.8008 272.629 37.8008C274.934 37.8008 276.681 39.4777 276.681 41.7136C276.681 43.9495 274.934 45.6264 272.629 45.6264C270.323 45.6264 268.576 43.9495 268.576 41.7136ZM275.633 41.7136C275.633 40.0367 274.375 38.779 272.699 38.779C270.952 38.779 269.694 40.0367 269.694 41.7136C269.694 43.3905 270.952 44.6482 272.699 44.6482C274.306 44.6482 275.633 43.3905 275.633 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M296.036 37.9375V45.5535H295.128L290.516 39.8939V45.5535H289.398V37.9375H290.307L294.918 43.5971V37.9375H296.036Z"
        fill="currentColor"
      />
      <path
        d="M309.311 41.7136C309.311 39.4777 311.057 37.8008 313.363 37.8008C314.551 37.8008 315.599 38.22 316.298 38.9886L315.599 39.6873C315.04 39.0585 314.271 38.779 313.433 38.779C311.686 38.779 310.428 40.0367 310.428 41.7136C310.428 43.3905 311.686 44.6482 313.433 44.6482C314.271 44.6482 314.97 44.3687 315.599 43.7398L316.298 44.4386C315.599 45.2071 314.551 45.6264 313.363 45.6264C311.057 45.6264 309.311 44.0193 309.311 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M328.875 41.7136C328.875 39.4777 330.622 37.8008 332.928 37.8008C335.233 37.8008 336.98 39.4777 336.98 41.7136C336.98 43.9495 335.233 45.6264 332.928 45.6264C330.552 45.6264 328.875 43.9495 328.875 41.7136ZM335.862 41.7136C335.862 40.0367 334.604 38.779 332.928 38.779C331.181 38.779 329.923 40.0367 329.923 41.7136C329.923 43.3905 331.181 44.6482 332.928 44.6482C334.604 44.6482 335.862 43.3905 335.862 41.7136Z"
        fill="currentColor"
      />
      <path
        d="M355.985 45.5535V39.9638L353.26 44.5753H352.701L349.976 39.9638V45.4836H348.928V37.9375H349.836L353.05 43.3176L356.194 37.9375H357.103V45.5535H355.985Z"
        fill="currentColor"
      />
      <path
        d="M376.176 40.5926C376.176 42.2695 374.988 43.2477 372.961 43.2477H371.075V45.5535H369.957V37.9375H372.961C374.918 37.9375 376.176 38.9157 376.176 40.5926ZM375.058 40.5926C375.058 39.4747 374.359 38.8458 372.961 38.8458H371.075V42.2695H372.961C374.359 42.2695 375.058 41.6407 375.058 40.5926Z"
        fill="currentColor"
      />
      <path
        d="M395.183 43.6669H391.13L390.292 45.5535H389.174L392.597 37.9375H393.646L397.139 45.5535H396.021L395.183 43.6669ZM394.764 42.7586L393.087 38.9856L391.41 42.7586H394.764Z"
        fill="currentColor"
      />
      <path
        d="M416.494 37.9375V45.5535H415.586L410.974 39.8939V45.5535H409.996V37.9375H410.904L415.516 43.5971V37.9375H416.494Z"
        fill="currentColor"
      />
      <path
        d="M433.89 42.8984V45.5535H432.842V42.8984L429.838 37.9375H431.026L433.471 41.99L435.917 37.9375H436.965L433.89 42.8984Z"
        fill="currentColor"
      />
      <path
        d="M86.1395 13.6914V32.4868H81.8075V24.8009H73.2832V32.4868H68.9512V13.6914H73.2832V21.0978H81.8075V13.6914H86.1395Z"
        fill="currentColor"
      />
      <path
        d="M103.748 28.4342H95.0139L93.337 32.4868H88.8652L97.2498 13.6914H101.512L109.896 32.4868H105.355L103.748 28.4342ZM102.35 25.1503L99.3459 17.9536L96.3415 25.1503H102.35Z"
        fill="currentColor"
      />
      <path
        d="M129.88 27.3163C129.88 30.5304 127.295 32.4169 122.404 32.4169H112.691V13.6914H121.845C126.526 13.6914 128.971 15.6478 128.971 18.5824C128.971 20.4689 127.993 21.9362 126.456 22.7048C128.552 23.4035 129.88 25.0106 129.88 27.3163ZM117.023 16.9754V21.3772H121.355C123.452 21.3772 124.639 20.6087 124.639 19.1414C124.639 17.6741 123.452 16.9754 121.355 16.9754H117.023ZM125.548 26.8971C125.548 25.29 124.36 24.5913 122.054 24.5913H116.954V29.2028H122.054C124.36 29.2028 125.548 28.5041 125.548 26.8971Z"
        fill="currentColor"
      />
      <path
        d="M146.369 28.4342H137.635L135.958 32.4868H131.486L139.871 13.6914H144.133L152.518 32.4868H147.976L146.369 28.4342ZM144.971 25.1503L141.967 17.9536L138.963 25.1503H144.971Z"
        fill="currentColor"
      />
      <path
        d="M153.846 30.6015L155.313 27.3176C156.92 28.5054 159.226 29.274 161.532 29.274C164.117 29.274 165.165 28.4355 165.165 27.2477C165.165 23.7541 154.265 26.1298 154.265 19.1426C154.265 15.9285 156.85 13.2734 162.16 13.2734C164.536 13.2734 166.912 13.8324 168.658 14.9503L167.331 18.2343C165.584 17.2561 163.767 16.767 162.16 16.767C159.575 16.767 158.597 17.7452 158.597 18.933C158.597 22.4266 169.497 19.9811 169.497 26.8983C169.497 30.0425 166.912 32.6977 161.532 32.6977C158.527 32.7675 155.523 31.9291 153.846 30.6015Z"
        fill="currentColor"
      />
      <path
        d="M190.388 13.6914V32.4868H186.056V24.8009H177.531V32.4868H173.199V13.6914H177.531V21.0978H186.056V13.6914H190.388Z"
        fill="currentColor"
      />
      <path
        d="M204.642 25.849V32.4868H200.31V25.7791L193.043 13.6914H197.654L202.685 22.0061L207.716 13.6914H211.978L204.642 25.849Z"
        fill="currentColor"
      />
      <path
        d="M221.76 23.0559C221.76 17.3963 226.092 13.3438 231.961 13.3438C235.175 13.3438 237.9 14.5316 239.717 16.6976L236.922 19.2828C235.664 17.8155 234.057 17.1168 232.171 17.1168C228.677 17.1168 226.162 19.5623 226.162 23.1257C226.162 26.6892 228.677 29.1347 232.171 29.1347C234.057 29.1347 235.664 28.3661 236.922 26.8988L239.717 29.484C237.97 31.65 235.245 32.8378 231.961 32.8378C226.092 32.768 221.76 28.7154 221.76 23.0559Z"
        fill="currentColor"
      />
      <path
        d="M241.812 23.0559C241.812 17.4662 246.145 13.3438 252.084 13.3438C257.953 13.3438 262.355 17.4662 262.355 23.0559C262.355 28.6456 257.953 32.768 252.084 32.768C246.145 32.768 241.812 28.6456 241.812 23.0559ZM257.953 23.0559C257.953 19.4924 255.437 17.0469 252.084 17.0469C248.73 17.0469 246.214 19.4924 246.214 23.0559C246.214 26.6193 248.73 29.0648 252.084 29.0648C255.437 29.0648 257.953 26.6193 257.953 23.0559Z"
        fill="currentColor"
      />
      <path
        d="M283.597 13.6914V32.4868H280.033L270.67 21.0978V32.4868H266.408V13.6914H269.972L279.334 25.0804V13.6914H283.597Z"
        fill="currentColor"
      />
      <path
        d="M292.61 17.2548H286.602V13.6914H302.951V17.2548H296.943V32.4868H292.61V17.2548Z"
        fill="currentColor"
      />
      <path
        d="M318.182 32.4868L314.549 27.2464H314.339H310.566V32.4868H306.234V13.6914H314.339C319.37 13.6914 322.514 16.2766 322.514 20.5388C322.514 23.3336 321.117 25.4298 318.671 26.4779L322.864 32.4868H318.182ZM314.06 17.2548H310.497V23.8227H314.06C316.715 23.8227 318.043 22.5651 318.043 20.5388C318.043 18.4427 316.715 17.2548 314.06 17.2548Z"
        fill="currentColor"
      />
      <path
        d="M339.074 28.4342H330.34L328.663 32.4868H324.191L332.576 13.6914H336.838L345.223 32.4868H340.681L339.074 28.4342ZM337.677 25.1503L334.672 17.9536L331.737 25.1503H337.677Z"
        fill="currentColor"
      />
      <path
        d="M346.551 23.0559C346.551 17.3963 350.883 13.3438 356.752 13.3438C359.966 13.3438 362.691 14.5316 364.508 16.6976L361.713 19.2828C360.455 17.8155 358.848 17.1168 356.962 17.1168C353.468 17.1168 350.953 19.5623 350.953 23.1257C350.953 26.6892 353.468 29.1347 356.962 29.1347C358.848 29.1347 360.455 28.3661 361.713 26.8988L364.508 29.484C362.761 31.65 360.036 32.8378 356.752 32.8378C350.883 32.768 346.551 28.7154 346.551 23.0559Z"
        fill="currentColor"
      />
      <path
        d="M371.845 17.2548H365.836V13.6914H382.186V17.2548H376.177V32.4868H371.845V17.2548Z"
        fill="currentColor"
      />
      <path
        d="M387.914 13.6914H392.246V32.4868H387.914V13.6914Z"
        fill="currentColor"
      />
      <path
        d="M416.141 13.6914V32.4868H412.578L403.215 21.0978V32.4868H398.953V13.6914H402.517L411.879 25.0804V13.6914H416.141Z"
        fill="currentColor"
      />
      <path
        d="M433.329 22.7747H437.172V30.1112C435.146 31.6483 432.421 32.4169 429.836 32.4169C424.106 32.4169 419.914 28.5041 419.914 23.0542C419.914 17.6042 424.106 13.6914 429.906 13.6914C433.12 13.6914 435.775 14.8093 437.522 16.8356L434.797 19.351C433.469 17.9536 431.932 17.3247 430.115 17.3247C426.622 17.3247 424.176 19.7003 424.176 23.124C424.176 26.5477 426.622 28.9233 430.045 28.9233C431.163 28.9233 432.281 28.7137 433.329 28.1548V22.7747Z"
        fill="currentColor"
      />
      <path
        d="M15.797 18.3909L16.0744 44.9547L23.7037 41.1401L23.6343 33.3027L34.3847 29.6961H34.4541L34.5928 44.816L41.043 41.0013L40.7656 16.4489L34.3154 16.5182L28.9749 19.5699L34.3847 19.5006L34.4541 28.4477L23.565 28.5864L23.4263 14.4375L14.4792 14.5069L9.13867 17.6279L15.7276 17.5586C15.797 17.836 15.797 18.1134 15.797 18.3909Z"
        fill="#838A46"
      />
      <path
        d="M48.464 0.84375H7.75126H0.46875V8.12626V50.7116V57.9941H7.75126H39.3088H42.3605L44.5106 55.8441L53.5964 46.7583L55.7465 44.6082V41.5565V8.12626V0.84375H48.464ZM48.464 41.6952L39.3782 50.7116H7.75126V8.12626H48.3946V41.6952H48.464Z"
        fill="url(#paint0_linear_425_5967)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_425_5967"
          x1="16.284"
          y1="14.6493"
          x2="61.3714"
          y2="71.1002"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0154639" stopColor="#838A46" />
          <stop offset="1" stopColor="#4A8A46" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Logo;
